<script>
import Vue from 'vue'

export default {
    methods: {
        $trans: function (t) {
            let trans = Vue.prototype.$translate.text(t);
            let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (!params || typeof params === 'undefined') {
                return trans;
            }

            Object.keys(params).forEach(function (key) {
                trans = trans.replace('%' + key + '%', params[key]);
            });

            return trans;
        }
    }
}

</script>


// WEBPACK FOOTER //
// Translate.vue?7360dc84